import { com } from '@eidu/web'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import getEntityType from './api/entity/type/getEntityType'
import { entityTypeKeys } from './queryKeys'
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId
import EntityType = com.eidu.sharedlib.entity.type.EntityType

export const fetchEntityType = async (id: EntityTypeId): Promise<EntityType | null> =>
  (await getEntityType({ id })) ?? null

const useEntityType = (id: EntityTypeId) => {
  const query = useQuery({
    queryKey: entityTypeKeys.detail(id),
    queryFn: () => fetchEntityType(id),
  })
  return {
    entityType: query.data,
    isLoading: query.isLoading,
    error: query.error,
  }
}

export const useFetchEntityType = () => {
  const queryClient = useQueryClient()
  return useCallback(
    (id: EntityTypeId) =>
      queryClient.fetchQuery({
        queryKey: entityTypeKeys.detail(id),
        queryFn: () => fetchEntityType(id),
      }),
    [queryClient]
  )
}

export default useEntityType
